export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a95d9f9cef8aa2d2fdd1169e5a396962.jpg"
          alt="Premium Club Atmosphere"
          className="w-full h-full object-cover object-center opacity-30 saturate-50"
        />
        <div className="absolute inset-0 bg-[#231D17]/60"></div>
      </div>

      <div className="relative z-10 w-full px-6 flex flex-col items-center justify-center min-h-screen">
        <div className="w-full max-w-4xl flex flex-col items-center">
          <img
            src="https://public.readdy.ai/ai/img_res/e31dc62e-5c8b-43f7-a810-159a2d301fa1.png"
            alt="The GodPadel™"
            className="w-full max-w-3xl h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}
